/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  if (document.querySelector('[data-product-json]')) {
    // Flag to track if the page has finished initial load
    let initialLoadComplete = false;

    document.addEventListener('theme:variant:change', (event) => {
      
      const variant = event.detail.variant;
      if (!variant) return;
    
      // Retrieve product JSON from the page.
      const productJsonEl = document.querySelector('[data-product-json]');
      let productOptions = [];
      if (productJsonEl) {
        try {
          const productData = JSON.parse(productJsonEl.innerHTML);
          productOptions = productData.options || [];
        } catch (e) {
          console.error('Error parsing product JSON:', e);
        }
      }
    
      // Find the index of the "Color" option.
      const colorIndex = productOptions.indexOf('Color');
      
      // Initialize selectedColorHandle
      let selectedColorHandle = '';
      
      if (colorIndex !== -1) {
        // Get the selected color value and convert to handle.
        const selectedColorValue = variant.options[colorIndex];
        selectedColorHandle = selectedColorValue.toLowerCase().replace(/[^a-z0-9]+/g, '-');
      } else {
        console.warn('No "Color" option found. Will display all images.');
        // We'll continue execution to show all images
      }
      
      /*=== Rebuild Main Product Slides by Removing and Reinserting ===*/
      // Flag to track if we're showing all slides due to no color match
      let showingAllSlides = false;
      
      const firstSlide = document.querySelector('.product__slide');
      if (firstSlide && firstSlide.parentNode && window.originalProductSlides) {
        const slidesContainer = firstSlide.parentNode;
        let matchingSlides = [];
        
        // Only filter slides if we have a color variant
        if (colorIndex !== -1) {
          matchingSlides = window.originalProductSlides.filter((slide) => {
            const imageHandle = slide.getAttribute('data-alt-handle') || '';
            // Use a more precise matching to avoid partial matches
            return isExactColorMatch(imageHandle, selectedColorHandle);
          });
        }
        
        // If no matching slides, use all original slides
        const slidesToUse = matchingSlides.length > 0 ? matchingSlides : window.originalProductSlides;
        showingAllSlides = matchingSlides.length === 0;
        
        slidesContainer.innerHTML = '';

        // Append each slide back into the container.
        slidesToUse.forEach((slide) => {
          slide.style.transition = "opacity 0.5s ease";
          slide.style.display = "block";
          slide.style.opacity = "0";
          slidesContainer.appendChild(slide);
          // Force a reflow before starting the fade-in.
          void slide.offsetWidth;
          slide.style.opacity = "1";
        });
      }

      /*=== Update Mobile Thumbs Slider === */
      const thumbsHolder = document.querySelector('product-thumbs .product__thumbs__holder');
      if (thumbsHolder && window.originalProductThumbs) {
        // Filter the stored mobile thumbs based on the selected color handle
        const originalThumbsCopy = window.originalProductThumbs.slice(); // or: [...window.originalProductThumbs]
  
        // Filter the copy based on the selected color handle.
        let matchingThumbs = [];
        
        // Only filter thumbs if we have a color variant
        if (colorIndex !== -1) {
          matchingThumbs = originalThumbsCopy.filter((thumb) => {
            const thumbHandle = thumb.getAttribute('data-alt-handle') || '';
            return isExactColorMatch(thumbHandle, selectedColorHandle);
          });
        }
        
        // If no matching thumbs, use all original thumbs
        const thumbsToUse = matchingThumbs.length > 0 ? matchingThumbs : originalThumbsCopy;

        // Clear the container
        thumbsHolder.innerHTML = '';

        // Append each thumb back into the container with a fade-in effect
        thumbsToUse.forEach((thumb, index) => {
          thumb.style.transition = "opacity 0.5s ease";
          thumb.style.display = "inline-block";
          thumb.style.opacity = "0";
          thumbsHolder.appendChild(thumb);
          // Force a reflow before starting the fade-in.
          void thumb.offsetWidth;
          thumb.style.setProperty('opacity', '1', 'important');
          thumb.classList.add('media--active');
          thumb.classList.remove('media--hidden');

          // If it's the first thumb and we're using all thumbs (no matches or no color variant)
          if (index === 0 && thumbsToUse === originalThumbsCopy) {
            // Mark as active
            thumb.classList.add('is-active');
            
            // Try to get data-media-id
            let mediaId = thumb.getAttribute('data-media-id');
            if (!mediaId) {
              const link = thumb.querySelector('[data-thumb-link]');
              mediaId = link ? link.getAttribute('data-media-id') : null;
            }
            
            if (mediaId) {
              // Update which slide is shown in main view
              const oldActiveSlide = document.querySelector('product-images .product__slide.media--active');
              if (oldActiveSlide) {
                oldActiveSlide.classList.remove('media--active');
                oldActiveSlide.classList.add('media--hiding');
              }
              
              const newActiveSlide = document.querySelector(`product-images .product__slide[data-media-id="${mediaId}"]`);
              if (newActiveSlide) {
                newActiveSlide.classList.remove('media--hiding');
                newActiveSlide.classList.add('media--active');
              }
            }
          }

          // Delay removing the is-loading class to avoid race conditions
          setTimeout(() => {
            const figure = thumb.querySelector('a figure img');
            if (figure) {
              figure.classList.remove('is-loading');
            }
          }, 100); // 100ms delay
        });
      }
    
      // Reinitialize the <zoom-images> element so it re-scans its children to start PhotoSwiper
      const zoomEl = document.querySelector('zoom-images');
      if (zoomEl) {
        // Deep-clone the element and replace the old one
        const newZoomEl = zoomEl.cloneNode(true);
        zoomEl.parentNode.replaceChild(newZoomEl, zoomEl);
        // console.log('<zoom-images> reinitialized.');
      }

      attachThumbClickHandlers();
    
      /* Update PhotoSwipe (Lightbox) Thumbs Template */
      const templateEl = document.querySelector('[data-pswp-thumbs-template]');
      if (templateEl && window.originalPswpThumbs) {
        let matchingThumbs = [];
        
        // Only filter thumbs if we have a color variant
        if (colorIndex !== -1) {
          matchingThumbs = window.originalPswpThumbs.filter((thumb) => {
            const thumbHandle = thumb.getAttribute('data-alt-handle') || '';
            return isExactColorMatch(thumbHandle, selectedColorHandle);
          });
        }
        
        // If no matching thumbs, use all original thumbs
        const thumbsToUse = matchingThumbs.length > 0 ? matchingThumbs : window.originalPswpThumbs;

        while (templateEl.content.firstChild) {
          templateEl.content.removeChild(templateEl.content.firstChild);
        }

        // Append each thumb back into the template.
        thumbsToUse.forEach((thumb) => {
          thumb.style.transition = "opacity 0.5s ease";
          thumb.style.display = "inline-block";
          thumb.style.opacity = "0"; // start hidden
          templateEl.content.appendChild(thumb);
          // Force a reflow before starting the fade-in.
          void thumb.offsetWidth;
          thumb.style.opacity = "1";
          thumb.classList.add('media--active');
          thumb.classList.remove('media--hidden');
        });
      }  

      /*=== Update Main Slider's Active Image for mobile ===*/
      setTimeout(() => {
        // If we're showing all images because there was no matching color image
        if (showingAllSlides) {
          // For initial page load with URL variant, use a more direct approach
          if (!initialLoadComplete) {
            // Get the first slide directly
            const firstSlide = document.querySelector('product-images .product__slide:first-child');
            if (firstSlide) {
              // Set it as active
              firstSlide.classList.add('media--active');
              firstSlide.classList.remove('media--hiding');
              
              // Remove active class from other slides
              const otherSlides = document.querySelectorAll('product-images .product__slide:not(:first-child)');
              otherSlides.forEach(slide => {
                slide.classList.remove('media--active');
                slide.classList.add('media--hiding');
              });
              
              // Set the active media in the product-images container
              const mediaId = firstSlide.getAttribute('data-media-id');
              if (mediaId) {
                const productImagesContainer = document.querySelector('product-images');
                if (productImagesContainer) {
                  productImagesContainer.setAttribute('data-active-media', mediaId);
                }
                
                // Also make the corresponding thumb active
                const firstThumb = document.querySelector(`.product__thumb[data-media-id="${mediaId}"]`);
                if (firstThumb) {
                  // Remove active class from any previously active thumbs
                  const activeThumb = document.querySelector('.product__thumb.is-active');
                  if (activeThumb) activeThumb.classList.remove('is-active');
                  firstThumb.classList.add('is-active');
                }
                
                // Dispatch the media select event
                firstSlide.dispatchEvent(new CustomEvent('theme:media:select', {
                  bubbles: true,
                  detail: { id: mediaId },
                }));
              }
            }
          } else {
            // For variant changes after page load, click the first thumbnail link
            const firstThumbLink = document.querySelector('.product__thumb .product__thumb__link');
            if (firstThumbLink) {
              firstThumbLink.click();
            }
          }
        } else {
          // Just dispatch the event for the active slide (for color-matched variants)
          const activeSlide = document.querySelector('product-images .product__slide.media--active');
          if (activeSlide) {
            const selectedMediaId = activeSlide.getAttribute('data-media-id');
            if (selectedMediaId) {
              activeSlide.dispatchEvent(new CustomEvent('theme:media:select', {
                bubbles: true,
                detail: { id: selectedMediaId },
              }));
            }
          }
        }
      }, 200); // Increased timeout for better reliability
    });

    // Function to properly match color handles without partial matches
    function isExactColorMatch(imageHandle, selectedColorHandle) {
      if (!imageHandle) return false;
      
      // Standardize the format by replacing underscores or spaces with dashes
      const standardizedHandle = imageHandle.replace(/[_\s]/g, '-');
      
      // Compare the standardized handle directly with the selected color handle
      return standardizedHandle === selectedColorHandle;
    }

    document.addEventListener('DOMContentLoaded', () => {
      // Store the original product slides 
      const firstSlide = document.querySelector('.product__slide');
      if (firstSlide && firstSlide.parentNode) {
        window.originalProductSlides = Array.from(firstSlide.parentNode.children);
      }

      // Store original mobile thumbs
      const mobileThumbs = document.querySelectorAll('product-thumbs .product__thumb');
      if (mobileThumbs.length) {
        window.originalProductThumbs = Array.from(mobileThumbs);
      }

      // Store the original PhotoSwipe thumbs
      const templateEl = document.querySelector('[data-pswp-thumbs-template]');
      if (templateEl) {
        window.originalPswpThumbs = Array.from(templateEl.content.querySelectorAll('.pswp__thumb'));
      }

      /*=== Logic for updating PDP images on load ===*/
      // Retrieve product JSON from the page.
      const productJsonEl = document.querySelector('[data-product-json]');
      if (productJsonEl) {
        try {
          const productData = JSON.parse(productJsonEl.innerHTML);
          let selectedVariant = null;

          // Check if the URL contains an active cariant
          const urlParams = new URLSearchParams(window.location.search);
          const variantIdParam = urlParams.get('variant');

          if (variantIdParam && productData.variants) {
            // Find the variant that matches the provided variant ID.
            selectedVariant = productData.variants.find(variant => variant.id.toString() === variantIdParam);
          }
          
          // Fallback to the first variant if no match is found.
          if (!selectedVariant && productData.variants) {
            selectedVariant = productData.variants[0];
          }
          
          if (selectedVariant) {
            // Dispatch the event with the selected variant.
            document.dispatchEvent(new CustomEvent('theme:variant:change', {
              detail: { variant: selectedVariant }
            }));
            
            // Use a longer delay for initial page load to ensure everything is ready
            setTimeout(() => {
              initialLoadComplete = true;
            }, 500);
          }
        } catch (e) {
          console.error('Error parsing product JSON:', e);
        }
      }
    });
  }

  function attachThumbClickHandlers() {
    const thumbs = document.querySelectorAll('.product__thumb');
    thumbs.forEach((thumb) => {
      // Remove any existing click listener to avoid duplicates
      thumb.removeEventListener('click', handleThumbClick);
      // Attach the new click listener
      thumb.addEventListener('click', handleThumbClick);
    });
  }
  
  function handleThumbClick(e) {
    e.preventDefault();
    const thumb = e.currentTarget;
    
    // Try to get data-media-id from the thumb first.
    // If not found, look for it on the child <a> element.
    let mediaId = thumb.getAttribute('data-media-id');
    if (!mediaId) {
      const link = thumb.querySelector('[data-thumb-link]');
      mediaId = link ? link.getAttribute('data-media-id') : null;
    }
    if (!mediaId) return;
    
    // Update the main <product-images> container:
    const productImagesContainer = document.querySelector('product-images');
    if (productImagesContainer) {
      productImagesContainer.setAttribute('data-active-media', mediaId);
    }
    
    // Manually update the slides
    const oldActiveSlide = document.querySelector('product-images .product__slide.media--active');
    if (oldActiveSlide){
      oldActiveSlide.classList.remove('media--active');
      oldActiveSlide.classList.add('media--hiding');
    }
    const newActiveSlide = document.querySelector(`product-images .product__slide[data-media-id="${mediaId}"]`);
    if (newActiveSlide){
      newActiveSlide.classList.remove('media--hiding');
      newActiveSlide.classList.add('media--active');
    } 
    
    // Update which thumb is active
    const activeThumb = document.querySelector('.product__thumb.is-active');
    if (activeThumb) activeThumb.classList.remove('is-active');
    thumb.classList.add('is-active');
  }
  

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();